export const isPro = () => {
    let pro = false ;
    const { proActive } = window['JkitDashboardOption'];
    if(proActive){
        pro = true;
    }

    return pro;
}